import React, { useEffect } from 'react'
// import { useNavigate } from 'react-router-dom'
import { updateApiRecord } from 'services/ShopifyIntegrationService'
import { useDispatch } from 'react-redux'
import { Success, Error } from 'utils/alerts'
import ShopifyForm from './components/ShopifyForm'
import { getCompanyData, getCustomersData } from 'store/data/dataSlice'

const Edit = ({ id, record, setOpen, setSelectedData }) => {
    // const { id } = useParams()
    const dispatch = useDispatch()
    // const navigate = useNavigate()

    useEffect(() => {
        if (id) {
            // fetchData(id)
            // Explicitly load company and customer data for dropdowns
            dispatch(getCompanyData())
            dispatch(getCustomersData())
        } else {
            // Redirect to list page if no ID is provided
            setOpen(false)
            setSelectedData()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id])

    // const fetchData = id => dispatch(getRecord(id))

    const handleDiscard = () => {
        setOpen(false)
        setSelectedData()
    }

    const handleSubmit = data => {
        updateApiRecord(id, data)
            .then(() => {
                Success('Shopify integration updated successfully!')
                handleDiscard()
            })
            .catch(error => {
                console.error('Error updating Shopify integration:', error)
                const errorMessage = error.response?.data?.message || 'Failed to update integration'
                Error(errorMessage)
            })
    }

    // if (loading || !record) {
    //     return (
    //         <div className="flex items-center justify-center h-64">
    //             <div className="text-lg text-gray-600">Loading...</div>
    //         </div>
    //     )
    // }

    return (
        <>
            {/* <div className="flex flex-col gap-1 mb-3 sm:flex-row sm:items-center sm:justify-between">
                <h2 className="font-semibold text-black text-title-md2 dark:text-white">Edit Shopify Integration</h2>
            </div> */}
            <div className="flex flex-col items-center">
                <div className="w-full bg-white border rounded-sm border-stroke shadow-default dark:border-strokedark dark:bg-boxdark">
                    {/* <div className="px-5 py-3 border-b border-stroke dark:border-strokedark">
                        <h3 className="font-medium text-black dark:text-white">Update Shopify Integration</h3>
                    </div> */}
                    <div className="flex flex-col gap-3 p-6">
                        <ShopifyForm initialValues={record} onSubmit={handleSubmit} onCancel={handleDiscard} isEdit={true} />
                    </div>
                </div>
            </div>
        </>
    )
}

export default Edit
